import React from 'react';
import CustomerHeader from '../../components/ui/CustomerHeader';
import Footer from '../../components/ui/Footer';
import CheckoutFlow from './components/CheckoutFlow';

const CheckoutPage = () => (
  <div className="min-h-screen flex flex-col bg-background">
    <CustomerHeader />
    <main className="flex-1 pt-16 pb-16">
      <CheckoutFlow />
    </main>
    <Footer />
  </div>
);

export default CheckoutPage;
